import './FormAutosuggestProduct.css';

import * as Autosuggest from 'react-autosuggest';
import * as React from 'react';

import { AppState } from 'common/models/AppState';
import { Loading } from 'common/components/Loading';
import { Product } from 'common/api/models/Product';
import { ProductApi } from 'common/api/resources/ProductApi';
import { toApiError } from 'common/utils/api';

export interface FormAutosuggestProductProps {
  id: string;
  appState: AppState;
  autoFocus?: boolean;
  onChange: (field: string, value: string) => void;
}

export interface FormAutosuggestProductState {
  value: string;
  suggestions: Product[];
  isLoading: boolean;
  allProducts: Product[];
  error?: any;
}
export class FormAutosuggestProduct extends React.Component<FormAutosuggestProductProps, FormAutosuggestProductState> {
  state: FormAutosuggestProductState = { isLoading: true, suggestions: [], allProducts: [], value: '' };

  componentDidMount() {
    ProductApi.getAllProducts({ limit: 500 }).then(
      res => {
        this.setState({ allProducts: res.data, isLoading: false });
      },
      error => this.setState({ error: toApiError(error), isLoading: false })
    );
  }

  isSearchMatch(queryWords: string[], searchString: string): boolean {
    for (let word of queryWords) {
      if (searchString.indexOf(word) === -1) {
        return false;
      }
    }
    return true;
  }

  handleSuggestionsFetchRequested = (value: any) => {
    const products: Product[] = this.state.allProducts;

    let queryWords = value.value.toLowerCase().split(' ');
    let suggestions: Product[] = [];
    for (let product of products) {
      if (this.isSearchMatch(queryWords, (product.name + ' ' + product.sku).toLowerCase())) {
        suggestions.push(product);
        if (suggestions.length > 10) {
          break;
        }
      }
    }
    this.setState({ suggestions: suggestions });
  };

  handleSuggestionsClearRequested = () => {
    this.setState({ suggestions: [] });
  };

  handleSuggestionSelected = (event: React.FormEvent<any>, data: Autosuggest.SuggestionSelectedEventData<any>) => {
    event.preventDefault();
    if (data.suggestion && data.suggestion.id) {
      this.props.onChange(this.props.id, data.suggestion.id);
      this.setState({ value: '' });
    }
  };

  handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ value: e.target.value !== undefined ? e.target.value : '' });
  };

  shouldRenderSuggestions(value: string) {
    return true;
  }

  getSuggestionValue = (product: string) => {
    return product;
  };

  renderSuggestion = (product: Product) => {
    return (
      <div>
        <b>{product.name}</b> ({product.sku})
      </div>
    );
  };

  render() {
    const inputProps = {
      value: this.state.value,
      onChange: this.handleChangeInput,
      autoFocus: this.props.autoFocus,
      placeholder: 'Type the name or SKU of a product',
    };
    const { isLoading, error, suggestions } = this.state;

    if (isLoading) {
      return <Loading />;
    }

    if (error) {
      return <div className="alert alert-danger">{error}</div>;
    }

    return (
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
        onSuggestionSelected={this.handleSuggestionSelected}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={this.renderSuggestion}
        inputProps={inputProps}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/form/FormAutosuggestProduct.tsx